import { useCallback, useEffect, useMemo } from 'react';
import { getIsFieldRequired } from 'utils';

import { useMask } from '@atlas/react-forms';

//This component created to avoid diplication
const useNumberFieldBase = ({
  field,
  onBlur = () => {},
  onChange,
  onFocus = () => {},
  valueTransformer,
}) => {
  const {
    active,
    amountIcon,
    autofocus,
    className,
    disabled,
    errors,
    hint,
    isModifiable = true,
    label,
    maskOption,
    name,
    placeholder,
    rules,
    touched,
    uiTitleClassName,
    value,
  } = field;

  const {
    handleBeforeInput,
    handleChange: handleMaskChange,
    handleKeyDown,
    maskedValue,
    value: cleanValue,
  } = useMask({
    digitsOnly: true,
    mask: maskOption,
  });

  const changeHandler = useCallback(
    event => {
      onChange(valueTransformer(event.target.value));
    },
    [onChange, valueTransformer],
  );

  useEffect(() => {
    if (maskOption) {
      onChange(valueTransformer(cleanValue));
    }
  }, [cleanValue, maskOption, onChange, valueTransformer]);

  useEffect(() => {
    if (value && String(value) !== cleanValue) {
      handleMaskChange({
        target: {
          selectionStart: String(value).length,
          value: String(value),
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleMaskChange, maskOption, value]);

  const error = touched && errors[0];
  const success = touched && !error;
  const isDisabled = disabled || !isModifiable;
  const isRequiredSymbol = useMemo(() => getIsFieldRequired(rules), [rules]);

  const sharedProps = {
    active,
    amountIcon,
    autoFocus: autofocus,
    className,
    disabled: isDisabled,
    error,
    isRequiredSymbol,
    label,
    name,
    onBlur,
    onFocus,
    success,
    touched,
    uiTitleClassName,
  };

  return {
    changeHandler,
    handleBeforeInput,
    handleKeyDown,
    handleMaskChange,
    hint,
    isDisabled,
    maskOption,
    maskedValue,
    placeholder,
    sharedProps,
    value,
  };
};

export default useNumberFieldBase;
